var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.badge
    ? _c(
        "div",
        {
          staticClass:
            "badge type-body-small ttu lh-title absolute top-0 right-0 mt3 mr3 bg-sold-out same-as-bg",
          class: _vm.badge.classes
        },
        [_vm._v("\n  " + _vm._s(_vm.badge.text) + "\n")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }